import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { LazyLoadEvent } from "primeng/api";
import { BehaviorSubject, Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {
lazyLoad$ = new BehaviorSubject<LazyLoadEvent | null>(null);

      constructor(private httpClient: HttpClient,private route:Router){}
      baseproperties: Baseproperties = new Baseproperties(); 
      private baseURL = this.baseproperties.gatewayBaseURL+'/common'; 

      getgrid(): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/organisation/getorggrid`);
      }
      getgridlazyload(payload): Observable<any> {
     return this.httpClient.post(`${this.baseURL}/organisation/getorggrid`,payload);
}
      exceldownload(){    
         return this.httpClient.get(`${this.baseURL}/organisation/getsuperadminexcel`,{ responseType: 'blob' }); 
      }
        downloadExcelData(api,http,payload) {
    if(http=='get'){
    return this.httpClient.get(`${this.baseURL}/${api}?orgid=${payload}`, { responseType: 'blob' });  // audit generate excel
    }else{
      return this.httpClient.post(`${this.baseURL}/${api}`,payload, { responseType: 'blob' });  // audit generate excel

    }
  }
      getConfigurationbyid(id): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/organisation/getgrid`);
      }
      getproductforlist(): Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/user/productdata`);
      }
      getorgdetailsbyId(id):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getmodify/${id}`);

      }
      saveorg(payload):Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/organisation/add/`,payload);

      }
       modifyorg(payload):Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/organisation/modify/`,payload);

      }
        modifybduser(payload):Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/organisation/bd_modify/`,payload);

      }

      modifyappconfigdatasuperadmin(payload):Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/organisation/modifyconfigurationsuperadmin/`,payload);

      }
      modifyappconfigdataadmin(payload):Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/organisation/modifyconfigurationadmin/`,payload);

      }
      getstatelist():Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getstate`);
      }
      
       getselectedstatelist(orgid):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/selectedState/${orgid}`);
      }

       getcountrylist():Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getcountry`);

      }

      getproductlist():Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getproduct`);

      }
        getproductemailflaglist(orgid):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getproductemailflag/${orgid}`);

      }
         getOrganisationProductlist(orgid):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getOrganisationProduct/${orgid}`);

      }
      
          getadmindetailsbyorgid(orgid):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getadmindetails/${orgid}`);

      }

       logoUpload(data: FormData): Observable<any> {    
      return this.httpClient.post<Observable<any>>(`${this.baseURL}/organisation/uploadlogo`, data);
    }
        getorgfiledetailsbyorgid(orgid):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getorgfiledetails/${orgid}`);

      }
      gettraingsdatabyorgid(orgid):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/gettraingsdata/${orgid}`);

      }
      
      getcomlocusernumberabyorgid(orgid):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getcomlocusernumber/${orgid}`);

      }
      
        gettablelicensedatabyorgid(orgid):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/gettablelicensedata/${orgid}`);

      }
      // modifyproductemailflag
       modifyproductemailflag(payload):Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/organisation/modifyproductemailflag`,payload);

      }
      
       getbdteamsdata(loginid):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/organisation/getbdteams/${loginid}`);

      }
    



}
